import {prepare, submit} from '../request_client';
import {resolveUrls} from '../utils';

const login = async () => {
  window.location = `${resolveUrls(location.hostname, 'api$$suffix$$')}:${location.port}/api/v1/session/login?redirect_uri=${resolveUrls(location.hostname, 'docs$$suffix$$')}:${location.port}`;
};

const logout = async () => {
  const request = await prepare({
    route: '/api/v1/authenticate/logout',
    base_url: `${resolveUrls(location.hostname, 'idp$$suffix$$')}:${location.port}`,
    method: 'post'
  });
  const {body} = await submit(request);
  window.location = `${resolveUrls(location.hostname, 'docs$$suffix$$')}:${location.port}`;
};

const getProfile = async () => {
  const request = await prepare({
    route: '/api/v1/session',
    base_url: `${resolveUrls(location.hostname, 'api$$suffix$$')}:${location.port}`,
    method: 'get'
  });
  const {body} = await submit(request);
  if (!body.id_token || !body.access_token) {
    store.dispatch({type: 'ADD_ITEM', data: 'Login'});
  }
  else {
    store.dispatch({type: 'SET_IDENTITY', data: body});
    store.dispatch({type: 'ADD_ITEM', data: 'Logout'});
  }
};

getProfile();

export default {
  CONSTRUCT() {
    return {
      history: [],
      pending: {},
      popup: false,
      base_url: 'http://localhost:8080',
      identity: null
    };
  },
  SET_IDENTITY(state, data) {
    const id = data.id_token;
    return state.set('identity', id);
  },
  LOGOUT_REQUEST(state) {
    logout();
    return state.set('identity', null);
  },
  LOGIN_REQUEST(state) {
    login();
    return state;
  },
  SUBMIT_REQUEST(state, request) {
    return state.setIn(['pending', request.id], request);
  },
  RECEIVE_RESPONSE(state, response) {
    const request = state.getIn(['pending', response.id]);
    return state.updateIn(['history'], log => log.concat({request, response})).deleteIn(['pending', response.id]).set('popup', true);
  },
  CLOSE_RESPONSE_POPUP(state) {
    return state.set('popup', false);
  },
  UPDATE_BASE_URL(state, url) {
    return state.set('base_url', url);
  }
};
